import type { CasaLeonOperationalEvent } from '@casa-leon-vivo/contracts/casa-leon';

const STORAGE_KEY = 'modo-vivo-demo-journal-v1';

export interface DemoPersistenceBlob {
  version: 1;
  journal: CasaLeonOperationalEvent[];
  savedAt: number;
}

export function saveDemoJournal(journal: CasaLeonOperationalEvent[]): void {
  if (typeof localStorage === 'undefined') return;
  const blob: DemoPersistenceBlob = {
    version: 1,
    journal,
    savedAt: Date.now(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(blob));
}

export function loadDemoJournal(): CasaLeonOperationalEvent[] | null {
  if (typeof localStorage === 'undefined') return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as DemoPersistenceBlob;
    if (parsed.version !== 1 || !Array.isArray(parsed.journal)) return null;
    return parsed.journal;
  } catch {
    return null;
  }
}

export function clearDemoJournal(): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(STORAGE_KEY);
}
